import { useRecoilValue } from 'recoil';
import {
    SaveDICOMToCacheRequestBody,
    useSaveDICOMToCache,
} from '~/backend/connector-api/connector-components';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import { environmentState } from '~/state/atoms/engineAtoms';
import { handleError } from '~/utils/errors';

/**
 * Handles uploading of structure set for cache update.
 * @returns {Function} - A start function to initiate cache update for current structure set.
 */
export default function useDoseCacheUpdate() {
    const currentDoseMatrix = useRecoilValue(currentDoseState);
    const environment = useRecoilValue(environmentState);
    const { mutateAsync: saveDICOMToCache } = useSaveDICOMToCache();

    const update = async () => {
        try {
            if (environment && currentDoseMatrix) {
                const formData = new FormData();
                formData.append(
                    'files',
                    currentDoseMatrix.dicomDose.getAsDicomBlob(),
                    `RD_${currentDoseMatrix.dicomUid}.dcm`
                );
                await saveDICOMToCache({
                    body: formData as unknown as SaveDICOMToCacheRequestBody,
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }
        } catch (error) {
            handleError(
                error,
                'Failed to update cached file for structure set.'
            );
        }
    };

    return update;
}
